import React from 'react';
import {FaGlobeAmericas} from "react-icons/fa";

const Graduate = ({
    title,
    projectNr,
    facility,
    image
}) => {
    return (
        <div className='graduate flex col jc-sb'>
            <div>
                <h3>{title}</h3>
                { facility &&
                    <span className='facility flex gap-sm'><FaGlobeAmericas className='icon'/>{facility}</span>
                }
            </div>
            <div className='flex col'>
                <img src={'/images/graduates/' + image} alt={projectNr} />
                <span className='project'>{projectNr}</span>
            </div>
        </div>
    );
};

export default Graduate;